import React from "react";
import { ShieldCheck, User, MapPin, Phone, Mail, FileText } from "lucide-react";

export default function Datenschutz() {
  return (
    <main className="legal-page flex flex-col items-center min-h-screen py-12 px-4 bg-gradient-to-br from-black via-[#181818] to-[#222]">
      <div className="max-w-xl w-full bg-[#181818] rounded-2xl shadow-2xl p-10 border border-[#FFD700]/40 relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#FFD700]/60 via-transparent to-[#FFD700]/60 rounded-t-2xl" />
        <div className="flex flex-col items-center mb-8">
          <span className="bg-[#FFD700]/20 p-4 rounded-full mb-4">
            <ShieldCheck size={40} className="text-[#FFD700]" />
          </span>
          <h1 className="text-4xl font-extrabold text-[#FFD700] mb-2 text-center drop-shadow-lg tracking-wide">Datenschutzerklärung</h1>
          <div className="h-1 w-16 bg-[#FFD700]/60 rounded-full mb-2" />
        </div>
        <section className="space-y-6 text-white text-lg font-light">
          <div>
            <h2 className="text-xl font-semibold text-[#FFD700] flex items-center gap-2 mb-2">
              <FileText size={20} className="text-[#FFD700]" /> 1. Einleitung
            </h2>
            <p>
              Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Ihre Daten werden vertraulich und entsprechend der gesetzlichen Vorschriften behandelt.
            </p>
          </div>
          <div>
            <h2 className="text-xl font-semibold text-[#FFD700] flex items-center gap-2 mb-2">
              <User size={20} className="text-[#FFD700]" /> 2. Verantwortliche Stelle
            </h2>
            <p>
              Rwan Cut<br />
              Inhaber: Rwan Mamo<br />
              Hellweg 15, 44787 Bochum<br />
              <span className="flex items-center gap-2">
                <Phone className="text-[#FFD700]" size={18} />
                <a href="tel:+491726060056" className="text-[#FFD700] hover:underline">+49 172 6060056</a>
              </span>
              <span className="flex items-center gap-2">
                <Mail className="text-[#FFD700]" size={18} />
                <a href="mailto:rwanmaamo@gmail.com" className="text-[#FFD700] hover:underline">rwanmaamo@gmail.com</a>
              </span>
            </p>
          </div>
          <div>
            <h2 className="text-xl font-semibold text-[#FFD700] flex items-center gap-2 mb-2">
              <FileText size={20} className="text-[#FFD700]" /> 3. Erhebung und Speicherung personenbezogener Daten
            </h2>
            <p>
              Wir erheben personenbezogene Daten, wenn Sie uns diese im Rahmen einer Anfrage mitteilen (z. B. Name, Telefonnummer, E-Mail-Adresse).
            </p>
          </div>
          <div>
            <h2 className="text-xl font-semibold text-[#FFD700] flex items-center gap-2 mb-2">
              <FileText size={20} className="text-[#FFD700]" /> 4. Weitergabe von Daten
            </h2>
            <p>
              Eine Übermittlung Ihrer persönlichen Daten an Dritte findet nur statt, wenn dies gesetzlich erlaubt ist oder Sie eingewilligt haben.
            </p>
          </div>
          <div>
            <h2 className="text-xl font-semibold text-[#FFD700] flex items-center gap-2 mb-2">
              <ShieldCheck size={20} className="text-[#FFD700]" /> 5. Ihre Rechte
            </h2>
            <p>
              Sie haben jederzeit das Recht auf Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger, sowie den Zweck der Datenverarbeitung. Außerdem haben Sie ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten.
            </p>
          </div>
          <div>
            <h2 className="text-xl font-semibold text-[#FFD700] flex items-center gap-2 mb-2">
              <Mail size={20} className="text-[#FFD700]" /> 6. Kontakt
            </h2>
            <p>
              Wenn Sie Fragen zum Datenschutz haben, wenden Sie sich bitte an uns unter den im Impressum angegebenen Kontaktdaten.
            </p>
          </div>
        </section>
      </div>
    </main>
  );
}